/** 周排查：（质量）安全风险隐患输入项 */
export const WEEKLY_SAFETY_NOTE_FIELDS = [
  {
    key: 'lastWeekRectification',
    label: '1.上周（质量）安全风险隐患问题整改核实情况'
  },
  {
    key: 'thisWeekRectification',
    label: '2.本周主要（质量）安全风险隐患和整改情况'
  }
]

export const WEEKLY_SAFETY_EVALUATION_TITLE = '3.本周（质量）安全管理情况评价：'

export const WEEKLY_SAFETY_EVALUATION_OPTIONS = [
  {
    value: 'controllable',
    label: '（质量）安全风险可控，无较大（质量）安全风险隐患'
  },
  {
    value: 'needs_action',
    label: '存在（质量）安全风险隐患，需尽快采取防范措施'
  }
]

export function createDefaultWeeklySafetyInputs() {
  return {
    lastWeekRectification: '无',
    thisWeekRectification: '无',
    safetyEvaluation: 'controllable'
  }
}

export function formatWeeklySafetyEvaluationText(selectedValue, options = WEEKLY_SAFETY_EVALUATION_OPTIONS) {
  return options
    .map((opt) => {
      const mark = selectedValue === opt.value ? '✓' : '☐'
      return `${mark}  ${opt.label}`
    })
    .join('\n')
}
